export default __webpack_public_path__ + "static/media/staking-coins-left.b0789ee6.svg";